import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

export function useCourseOverridesMutations({ courseId }) {
  const queryClient = useQueryClient();

  const createOverridesBulkRemovalMutation = useMutation({
    mutationFn: async ({ overridesBulkRemovalParams }) => {
      const response = await axios.post(`/overrides/bulk_removals`, {
        overrides_bulk_removal: overridesBulkRemovalParams,
      });

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['courseOverrides', courseId]);
    },
  });

  return { createOverridesBulkRemovalMutation };
}
